var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightSizingCostArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D01A1A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00053 5C8.16353 5 8.31653 5.0795 8.41003 5.2135L11.91 10.2135C12.017 10.366 12.029 10.5655 11.944 10.731C11.8575 10.8965 11.687 11 11.5005 11H4.49953C4.31303 11 4.14253 10.8965 4.05603 10.731C3.97103 10.5655 3.98303 10.366 4.09003 10.2135L7.59003 5.2135C7.68353 5.0795 7.83653 5 7.99953 5H8.00053Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSizingCostArrow);
export default __webpack_public_path__ + "static/media/rightSizingCostArrow.c0897fe6b3cbbb8b9ae49706a2f2cf12.svg";
export { ForwardRef as ReactComponent };